import React from 'react';
import { Star } from 'lucide-react';
import { SectionWrapper } from './SectionWrapper';
const testimonials = [{
  text: 'Me dio la seguridad que me faltaba al atender adolescentes. Los protocolos de riesgo suicida y las plantillas legales son oro puro para la práctica diaria en Argentina.',
  author: 'Dra. María Laura F.',
  role: 'Psiquiatra Infantojuvenil (CABA)'
}, {
  text: 'Como residente, este material me ordenó la cabeza. Lo que no te enseñan sobre la Ley 26.061 y cómo documentar, acá está resuelto y listo para usar.',
  author: 'Dr. Javier S.',
  role: 'Residente de Psiquiatría (Córdoba)'
}, {
  text: 'Excelente inversión. El módulo de informes para el juzgado de familia me ahorró horas de trabajo y angustia. Totalmente adaptado a nuestra realidad.',
  author: 'Dra. Ana P.',
  role: 'Psiquiatra (Rosario)'
}];
export function SocialProof() {
  return <div className="bg-slate-50 border-b border-slate-200/60" data-id="element-204">
      <SectionWrapper className="!py-8 md:!py-16" data-id="element-205">
        <div className="text-center mb-6 md:mb-10" data-id="element-206">
          <div className="flex justify-center items-center gap-2 mb-2 md:mb-3" data-id="element-207">
            <div className="flex" data-id="element-208">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 text-amber-500 fill-amber-500" data-id="element-209" />)}
            </div>
            <span className="font-bold text-slate-800 text-base md:text-lg" data-id="element-210">
              4.9/5
            </span>
          </div>
          <h2 className="text-[20px] md:text-2xl font-bold text-slate-900 mb-1 md:mb-2 text-balance" data-id="element-211">
            +800 PROFESIONALES LO USAN
          </h2>
          <p className="text-slate-600 text-[14px] md:text-base" data-id="element-212">
            Lo que dicen los profesionales
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-213">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm ring-1 ring-slate-900/5 flex flex-col justify-between hover:shadow-md transition-shadow" data-id="element-214">
              <div className="mb-4" data-id="element-215">
                <div className="flex mb-3" data-id="element-216">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 md:w-4 md:h-4 text-amber-400 fill-amber-400" data-id="element-217" />)}
                </div>
                <p className="text-slate-700 text-[14px] italic leading-relaxed" data-id="element-218">
                  "{t.text}"
                </p>
              </div>
              <div data-id="element-219">
                <p className="font-semibold text-slate-900 text-[14px]" data-id="element-220">
                  {t.author}
                </p>
                <p className="text-[12px] text-slate-500" data-id="element-221">{t.role}</p>
              </div>
            </div>)}
        </div>
      </SectionWrapper>
    </div>;
}